import React, { useEffect, useState } from "react";
import { FlexRowBetween, Button, GenericDiv, Input } from "../Style";
import { useSelector } from "react-redux";
import { addAlpha } from "../others/Functions";
import FilterBar from "../others/FilterBar";
import Submit from "./Submit";
import FilledLoading from "../loader/FilledLoading";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { editArrival } from "../../../store/reducers/guestsReducer";
import GenericModal from "../modals/GenericModal";
import YesNoModal from "../modals/YesNoModal";

const GenericArivalConfirmation = ({
  heartColor,
  transportation,
  specialMsg,
  transportationDetails,
  specialMsgDetails,
  specialDishes,
  acceptLimit,
  isDemo,
  blessing,
  blessTitle,
  seuda,
  gId,
  invK,
  separation,
  uId,
}) => {
  const dispatch = useDispatch();
  let categories = [
    { id: "נגיע", name: "נגיע" },
    { id: "אולי", name: "אולי" },
    { id: "לא נוכל להגיע", name: "לא נוכל להגיע" },
  ];
  const [selfFullname, setFullname] = useState("");
  const [selfPhone, setPhone] = useState("");
  const [category, setCategory] = useState("נגיע");
  const [showAcceptForm, setShowAcceptForm] = useState(false);
  const [showMaybeForm, setShowMaybeForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [seudaQ, setSeudaQ] = useState(false);

  const handleSetShowAcceptForm = () => {
    setSeudaQ(false);
    setShowAcceptForm(true);
  };

  const handleDis = (notes) => {
    if (isDemo) {
      setSeudaQ(false);
      toast.success("הפעולה בוצעה בהצלחה");
    } else {
      setLoading(true);
      dispatch(
        editArrival(gId, {
          accept: 0,
          notes,
          acceptWomen: 0,
          acceptMen: 0,
          ans: selfFullname.length ? "S" : "L",
          selfFullname,
          selfPhone,
          uId,
        })
      ).then((res) => {
        setLoading(false);
        if (!res.payload?.error) {
          toast.success("תודה רבה על תשובתך!");
          setSeudaQ(false);
          setDone(true);
        } else toast.error(res.payload?.error);
      });
    }
  };

  const handleSubmit = () => {
    let isSelf = gId?.length > 0;
    let isOk = true;
    let phone1 = selfPhone;
    if (!isSelf && !isDemo) {
      if (phone1[0] === "0") phone1 = phone1.substring(1);
      phone1 = phone1.replaceAll("-", "");
      phone1 = phone1.replaceAll(/[^\d]/g, "");

      const regex = /^[5]{1}[0-9]{8}$/g;
      const validatePhone = phone1.match(regex);
      if (
        selfFullname.length < 1 ||
        selfFullname.length > 30 ||
        !validatePhone
      ) {
        isOk = false;
        toast.warning("נא למלא שם מלא (2-30 תווים) ומספר נייד ישראלי חוקי");
      } else setPhone(phone1);
    }
    if (isOk) {
      if (category === "אולי") setShowMaybeForm(true);
      else if (category === "נגיע") {
        if (seuda) setSeudaQ(true);
        else setShowAcceptForm(true);
      } else {
        if (isDemo) toast.success("הפעולה בוצעה בהצלחה");
        else handleDis("");
        setDone(true);
      }
    }
  };

  const handleNoMaybe = () => {
    if (isDemo) toast.success("הפעולה בוצעה בהצלחה");
    else {
      setLoading(true);
      dispatch(
        editArrival(gId, {
          accept: null,
          acceptWomen: null,
          acceptMen: null,
          notes: "לא יודעים, להמשיך לבדוק",
          ans: selfFullname.length ? "S" : "L",
          selfFullname,
          selfPhone,
          uId,
        })
      ).then((res) => {
        setLoading(false);
        if (!res.payload?.error) {
          toast.success("תודה רבה על תשובתך!");
        } else toast.error(res.payload?.error);
      });
    }
    setShowMaybeForm(false);
    setDone(true);
  };

  const handleYesMaybe = () => {
    if (isDemo) toast.success("הפעולה בוצעה בהצלחה");
    else {
      setLoading(true);
      dispatch(
        editArrival(gId, {
          accept: 0,
          acceptWomen: 0,
          acceptMen: 0,
          notes: "לא לקחת בחשבון כרגע, יעדכנו בקישור במידה ויהיה שינוי",
          ans: selfFullname.length ? "S" : "L",
          selfFullname,
          selfPhone,
          uId,
        })
      ).then((res) => {
        setLoading(false);
        if (!res.payload?.error) {
          toast.success("תודה רבה על תשובתך!");
        } else toast.error(res.payload?.error);
      });
    }
    setShowMaybeForm(false);
    setDone(true);
  };

  return (
    <>
      {gId?.length > 0 || isDemo ? null : (
        <>
          <FlexRowBetween
            style={{
              width: "90%",
              margin: "0px auto",
              marginTop: "20px",
              background: `${addAlpha(heartColor, 0.3)}`,
              padding: "20px",
              borderRadius: "5px",
            }}
          >
            <div style={{ position: "relative", width: "50%" }}>
              <Input
                style={{ padding: "8px 0", paddingRight: "5px" }}
                placeholder={"שם מלא"}
                onChange={(e) => setFullname(e.target.value)}
              />
            </div>
            <div style={{ position: "relative", width: "40%" }}>
              <Input
                style={{ padding: "8px 0", paddingRight: "5px" }}
                placeholder={"מס׳ נייד"}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
          </FlexRowBetween>
        </>
      )}
      {done ? (
        <>
          <GenericDiv
            onClick={() => setDone(false)}
            style={{
              padding: "10px 55px",
              borderRadius: "60px",
              boxShadow: "0 2px 4px silver",
              color: "white",
              position: "relative",
              fontWeight: "700",
              fontSize: "16px",
              background: invK === 2 ? "inherit" : heartColor,
              background: `linear-gradient(to right,${addAlpha(
                heartColor,
                1
              )},${addAlpha(heartColor, 0.6)})`,
              background: heartColor,
              width: "min-content",
              margin: "0 auto",
              marginTop: "15px",
            }}
          >
            שליחה מחדש
          </GenericDiv>
        </>
      ) : (
        <>
          <FlexRowBetween
            style={{ justifyContent: "center", marginTop: "30px" }}
          >
            <FilterBar
              color={heartColor}
              padding={"7px 12px"}
              data={categories}
              setProperty={setCategory}
              property={category}
            />
          </FlexRowBetween>

          <FlexRowBetween
            style={{ justifyContent: "center", marginTop: "10px" }}
          >
            <GenericDiv
              id="bla"
              onClick={handleSubmit}
              className="animate__animated animate__pulse animate__infinite"
              style={{
                marginTop: "10px",
                padding: "10px 55px",
                borderRadius: "60px",
                boxShadow: "0 2px 4px silver",
                color: "white",
                fontWeight: "700",
                fontSize: "16px",
                background: invK === 2 ? "inherit" : heartColor,
                background: `linear-gradient(to right,${addAlpha(
                  heartColor,
                  1
                )},${addAlpha(heartColor, 0.6)})`,
                background: heartColor,
              }}
            >
              {category == "נגיע" ? "לחצו כאן לבחירת כמות" : "שליחה"}
            </GenericDiv>
          </FlexRowBetween>
        </>
      )}

      {showMaybeForm && (
        <GenericModal
          init={setShowMaybeForm}
          div={
            <YesNoModal
              yesColor={heartColor}
              title={"שאלה"}
              body={
                "האם זה בסדר מבחינתך שנסמן כרגע שאינך מגיע/ה ובמידה ויהיה שינוי תוכל למלא תשובתך מחדש?"
              }
              no={handleNoMaybe}
              yes={handleYesMaybe}
              yesText={
                <div
                  style={{
                    width: "min-content",
                    height: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  כן, זה בסדר
                </div>
              }
              noText={
                <div
                  style={{
                    width: "min-content",
                    height: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  לא, תמשיכו לבדוק איתי
                </div>
              }
            />
          }
        />
      )}

      {showAcceptForm && (
        <GenericModal
          init={setShowAcceptForm}
          div={
            <Submit
              gId={gId}
              setDone={setDone}
              isDemo={isDemo}
              init={setShowAcceptForm}
              transportation={transportation}
              specialMsg={specialMsg}
              transportationDetails={transportationDetails}
              specialMsgDetails={specialMsgDetails}
              specialDishes={specialDishes}
              acceptLimit={acceptLimit}
              blessing={blessing}
              blessTitle={blessTitle}
              heartColor={heartColor}
              separation={separation}
              selfFullname={selfFullname}
              selfPhone={selfPhone}
              uId={uId}
            />
          }
        />
      )}

      {loading && <FilledLoading />}

      {seudaQ && (
        <GenericModal
          init={setSeudaQ}
          div={
            <YesNoModal
              title={"סעודה"}
              body={"האם תישארו לסעודה?"}
              no={() => handleDis("יגיע אבל לא יישאר לסעודה")}
              yes={handleSetShowAcceptForm}
            />
          }
        />
      )}
    </>
  );
};

export default GenericArivalConfirmation;

{
  /* <FlexRowBetween style={{ justifyContent: "center" }}>
          <div style={{ fontSize: "14px", marginLeft: "1px" }}>כמה אתם</div>
          <div style={{ fontSize: "14px" }}>?</div>
        </FlexRowBetween> */
}
